import { jwtDecode } from 'jwt-decode';

export function isTokenExpired(token) {
  if (!token) return true;

  try {
    const decoded = jwtDecode(token); 
    if (!decoded.exp) return true;

    const now = Math.floor(Date.now() / 1000);
    return decoded.exp < now;
  } catch (e) {
    return true;
  }
}

export function isTokenExpiringSoon(token, bufferSeconds = 60) {
  try {
    const { exp } = jwtDecode(token);
    const now = Math.floor(Date.now() / 1000);

    console.log(`Token expires in ${exp - now} seconds`);
    
    return exp - now < bufferSeconds;
  } catch {
    return true;
  }
}

export function getClaimFromToken(claimKey) {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const parts = token.split('.');
  if (parts.length !== 3) return null;

  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    const claims = JSON.parse(jsonPayload);

    // Try exact match first
    if (claims.hasOwnProperty(claimKey)) {
      return claims[claimKey];
    }

    // Fallback: find a key that ends with the claimKey
    const foundKey = Object.keys(claims).find(k => k.endsWith(`/${claimKey}`));
    return foundKey ? claims[foundKey] : null;

  } catch (e) {
    console.error('Failed to parse token', e);
    return null;
  }
}
